export default class WwindexService {
  getAll(params) {
      const queryParams = Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&');
      return fetch('https://api.tradersr.com/api/wwindex?' + queryParams).then(res => res.json())
  }
}